// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const PowerIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg width={width} height={height} viewBox="0 0 33 33" xmlns="http://www.w3.org/2000/svg">
          <path fill="inherit" d="M16.5 33C12.0914 33 7.95352 31.2855 4.83398 28.166C1.71445 25.0465 0 20.9086 0 16.5C0 12.0914 1.71445 7.95352 4.83398 4.83398C5.6332 4.03477 6.94805 4.03477 7.74727 4.83398C8.54648 5.6332 8.54648 6.94805 7.74727 7.74727C5.41406 10.0805 4.125 13.2 4.125 16.5C4.125 19.8 5.41406 22.9195 7.74727 25.2527C10.0805 27.5859 13.2 28.875 16.5 28.875C19.8 28.875 22.9195 27.5859 25.2527 25.2527C27.5859 22.9195 28.875 19.8 28.875 16.5C28.875 13.2 27.5859 10.0805 25.2527 7.74727C24.4535 6.94805 24.4535 5.6332 25.2527 4.83398C26.052 4.03477 27.3668 4.03477 28.166 4.83398C31.2855 7.95352 33 12.0914 33 16.5C33 20.9086 31.2855 25.0465 28.166 28.166C25.0465 31.2855 20.9086 33 16.5 33ZM16.5 18.5625C17.6344 18.5625 18.5625 17.6344 18.5625 16.5V2.0625C18.5625 0.928125 17.6344 0 16.5 0C15.3656 0 14.4375 0.928125 14.4375 2.0625V16.5C14.4375 17.6344 15.3656 18.5625 16.5 18.5625Z" />
        </svg>
      )
    }
  </Icon>
);

export default PowerIcon;
